import { useOrgContextOrgId } from '@townsquare/org-context';

/**
 * Includes the business logic for determining if teams is enabled.
 *
 * @returns boolean
 */
export const useIsTeamsEnabled = () => {
	const orgId = useOrgContextOrgId();
	return Boolean(orgId);
};
